import { render } from "./mvt-cardproperty-info.vue?vue&type=template&id=d0a68b20"
import script from "./mvt-cardproperty-info.vue?vue&type=script&lang=js"
export * from "./mvt-cardproperty-info.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__